import { useState } from 'react'
import { useContextSelector } from 'use-context-selector'

import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { SectionName } from 'types/types'

import dots from 'assets/img/admin/dots-menu.svg'
import s from './BlockWrap.module.scss'

type BlockWrapProps = {
  children: JSX.Element
  type: SectionName
  text?: string
  textFontSize?: string | number
  bgColor?: string
  setDraggable?: React.Dispatch<React.SetStateAction<boolean>>
}

export const BlockWrap = ({ children, type, text, textFontSize = 14, bgColor, setDraggable }: BlockWrapProps) => {
  const title = useContextSelector(
    PromoPageStateContext,
    (context) => context.state.sections.find((section) => section.type === type)?.title,
  )

  const [isVisible, setVisible] = useState(false)

  const clickHandler = () => {
    setVisible(!isVisible)
    setDraggable && setDraggable(isVisible) //когда какой-либо блок открыт - перемещать нельзя
  }

  return (
    <div className={s.block} style={{ backgroundColor: bgColor }}>
      <div className={[s.header, isVisible && s.open].join(' ')} onClick={clickHandler}>
        <h6 className={s.title} style={{ fontSize: textFontSize }}>
          {text || title}
        </h6>

        {setDraggable && (
          <div className={s.rightHeader}>
            <span className={s.line}></span>
            <img src={dots} alt="dots" />
          </div>
        )}
      </div>

      {isVisible && <div className={s.childrenWrap}>{children}</div>}
    </div>
  )
}
